import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { FiLock } from "react-icons/fi";

const NavItem = ({ permission, link, text, icon: Icon, badge, setIsOpen }) => {
  const userState = useSelector((state) => state.userState);
  const { userData } = userState;
  const location = useLocation();

  const hasPermission = permission
    ? userData && userData.permissions?.includes(permission)
    : true;

  const [linkPath, linkSearch] = (link || "").split("?");
  const isActive = Boolean(
    link
    && location.pathname === linkPath
    && (!linkSearch || location.search === `?${linkSearch}`)
  );

  if (!hasPermission) {
    return (
      <li className="dashboard-nav-item is-disabled">
        <span><FiLock /><span>{text}</span></span>
      </li>
    );
  }

  return (
    <li className={`dashboard-nav-item ${isActive ? "is-active" : ""}`}>
      <Link
        to={link || "/"}
        onClick={() => setIsOpen(false)}
        aria-current={isActive ? "page" : undefined}
      >
        {Icon ? <Icon /> : <span className="dashboard-nav-item__dot" />}
        <span>{text}</span>
        {badge && <small>{badge}</small>}
      </Link>
    </li>
  );
};

export default NavItem;
